import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { contact } from '../../partials/contact';
import { image } from '../../partials/image';

export const contactSlice = ({ primary }) => {
  const normalizedImage = image(primary);
  const normalizedContact = contact(primary);

  if (normalizedContact) {
    return clear({
      type: CommonSliceType.CONTACT,
      fullName: normalizedContact.fullName,
      job: normalizedContact.job,
      phone: normalizedContact.phone,
      email: normalizedContact.email,
      image: normalizedImage,
    });
  }
};
